"use client";

import {
  collection,
  doc,
  type CollectionReference,
  type DocumentReference,
} from "firebase/firestore";
import { getV3Db } from "./db";
import { V3_COLLECTIONS, type V3CollectionName } from "../types.v3";

export function v3UserDoc(uid: string): DocumentReference {
  return doc(getV3Db(), "users", uid);
}

export function v3Collection(
  uid: string,
  name: V3CollectionName,
): CollectionReference {
  return collection(getV3Db(), "users", uid, name);
}

export function v3Doc(
  uid: string,
  collectionName: V3CollectionName,
  docId: string,
): DocumentReference {
  return doc(getV3Db(), "users", uid, collectionName, docId);
}

export function v3GamesCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.games);
}
export function v3PeopleCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.people);
}
export function v3OrganizationsCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.organizations);
}
export function v3TeamsCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.teams);
}
export function v3LocationsCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.locations);
}
export function v3ExpensesCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.expenses);
}
export function v3MileageTripsCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.mileageTrips);
}
export function v3TaxConfigCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.taxConfig);
}
export function v3VoiceNotesCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.voiceNotes);
}
export function v3ExportsCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.exports);
}
export function v3ImportJobsCol(uid: string) {
  return v3Collection(uid, V3_COLLECTIONS.importJobs);
}

export function v3InvoicesCol(uid: string): CollectionReference {
  return v3Collection(uid, V3_COLLECTIONS.invoices);
}

export function v3AddressesCol(uid: string): CollectionReference {
  return v3Collection(uid, V3_COLLECTIONS.addresses);
}

export function v3SettingsCol(uid: string): CollectionReference {
  return v3Collection(uid, V3_COLLECTIONS.settings);
}

export function v3SettingDoc(uid: string, key: string): DocumentReference {
  return v3Doc(uid, V3_COLLECTIONS.settings, key);
}
